import React from "react";

export function LayoutColumns({ color = '#FFF', ...props }) {
  return (
    <svg width="24" height="24" viewBox="0 0 700 700" xmlns="http://www.w3.org/2000/svg" fill={color} {...props}>
      <path d="m350,0l-350,0l0,525l525,0l0,-525l-175,0zm-315,490l0,-455l315,0l0,455l-315,0z"/>
    </svg>
  );
}
